const SNOWPLOW_COOKIE_PREFIX = 'wca_spid';

const getSnowplowCookieValue = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookies = document.cookie.split('; ');
  const match = cookies.find(c => c.split('=')[0]?.startsWith(SNOWPLOW_COOKIE_PREFIX));
  return match ? match.split('=').slice(1).join('=') : null;
};

const getSnowplowHeaderValues = () => {
  try {
    const cookieValue = getSnowplowCookieValue();

    if (!cookieValue) {
      return {};
    }

    const parts = cookieValue.split('.');

    return {
      'x-data-user': parts[0] || undefined,
      'x-data-session': parts[5] || undefined,
    };
  } catch {
    return {};
  }
};

export default getSnowplowHeaderValues;
